import { render, staticRenderFns } from "./MatchMultipleProductSelectPrincipalAccordion.vue?vue&type=template&id=a152cd28&scoped=true&"
import script from "./MatchMultipleProductSelectPrincipalAccordion.vue?vue&type=script&lang=ts&"
export * from "./MatchMultipleProductSelectPrincipalAccordion.vue?vue&type=script&lang=ts&"
import style0 from "./MatchMultipleProductSelectPrincipalAccordion.vue?vue&type=style&index=0&id=a152cd28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a152cd28",
  null
  
)

export default component.exports